/**
 * Centralized site configuration
 */
export const siteConfig = {
  /** External booking/scheduling URL (Calendly, Cal.com, etc.) */
  bookingUrl: process.env.NEXT_PUBLIC_BOOKING_URL || '',
} as const;
